import { useTheme } from "@emotion/react";
import { Box, Typography } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const useStyles = makeStyles((theme) => ({
  desktop: {
    [theme.breakpoints.down("md")]: {
      display: "none",
    },
  },
  mobile: {
    [theme.breakpoints.up("md")]: {
      display: "none",
    },
  },
}));

export const TutoringIntroduction = () => {
  const { palette } = useTheme();
  const { desktop, mobile } = useStyles();
  return (
    <>
      <Box px={8} pt={10} pb={0} className={desktop}>
        <Box width="50%">
          <Typography variant="h2" color={palette.common.white}>
           Self Study & Personalized Tutoring
          </Typography>
        </Box>
        <Box width="70%" pt={2} pb={3}>
          <Typography
            variant="body3"
            component="p"
            color={palette.common.white}
          >
Word Voyage offers a variety of plans to fit each student's needs. Our self-study options are perfect for students wanting to master Latin roots and vocabulary from the books they are currently reading. For those needing more direct support, our tutoring plans provide intensive roots, vocabulary, and grammar instruction.
<a href="https://go.wordvoyage.com/tutoring_plans" 
                        target="_blank" 
                        style={{ color: "#FFCD00" }}
	  className="pl-2 ml-3"
                        > Learn more</a>.
            <br/><br/>
            To schedule a call with a Word Voyage specialist, <a href="https://go.wordvoyage.com/tutoring" 
                        target="_blank" 
                        style={{ color: "#FFCD00" }}
                        >Please click here</a>.
            <br/><br/>
            <b>Minimum time requirement:</b> 20 minutes per day, 5 days a week
          </Typography>
        </Box>
      </Box>

      <Box className={mobile} pt={8} pb={6}>
        <Box pb={2}>
          <Typography variant="h5" color={palette.common.white}>
           Self Study & Personalized Tutoring
          </Typography>
        </Box>
	            <Typography
            variant="body3"
            component="p"
            color={palette.common.white}
          >
Word Voyage offers a variety of plans to fit each student's needs. Our self-study options are perfect for students wanting to master Latin roots and vocabulary from the books they are currently reading. For those needing more direct support, our tutoring plans provide intensive roots, vocabulary, and grammar instruction.
<a href="https://go.wordvoyage.com/tutoring_plans"
                        target="_blank"
                        style={{ color: "#FFCD00" }}
                        >Learn more</a>.
            <br/><br/>
            To schedule a call with a Word Voyage specialist, <a href="https://go.wordvoyage.com/tutoring"
                        target="_blank"
                        style={{ color: "#FFCD00" }}
                        >Please click here</a>.
            <br/><br/>
            <b>Minimum time requirement:</b> 20 minutes per day, 5 days a week
          </Typography>
      </Box>
    </>
  );
};
